"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const UrlHelper_1 = __importDefault(require("./UrlHelper"));
/**
 * A class to build URLs that uses the URL class.
 */
class NextGenUrlBuilder {
    constructor(url) {
        this.url = url;
    }
    static fromUrl(url) {
        return new NextGenUrlBuilder(new URL(url));
    }
    /**
     * Create a new NextGenUrlBuilder from an absolute URL.
     *
     * @param path the path to build the URL from
     * @param tenant the tenant to use for the base URL and context prefix
     */
    static fromAbsoluteUrl(path, tenant) {
        var _a;
        return new NextGenUrlBuilder(new URL(UrlHelper_1.default.prefixBasePath(tenant, path), (_a = tenant.baseUrl) !== null && _a !== void 0 ? _a : 'https://khoros.com'));
    }
    /**
     * Convert legacy query parameters to a format that can be used by the URLSearchParams constructor.
     * @param queryParameters
     */
    static convertLegacyQueryParams(queryParameters) {
        if (queryParameters &&
            !Array.isArray(queryParameters) &&
            typeof queryParameters !== 'string' &&
            !(queryParameters instanceof URLSearchParams) &&
            Object.values(queryParameters).some(value => Array.isArray(value))) {
            return Object.entries(queryParameters).flatMap(([key, value]) => {
                if (Array.isArray(value)) {
                    return value.map(nestedValue => [key, nestedValue]);
                }
                return [[key, value]];
            });
        }
        else {
            return queryParameters;
        }
    }
    /**
     * Add a query to the URL.
     *
     * @param queryParameters the query parameters to add
     * @param append whether to append the query parameters to the existing query
     */
    addQuery(queryParameters, append = true) {
        const legacySupportQueryParams = NextGenUrlBuilder.convertLegacyQueryParams(queryParameters);
        const newSearchParams = new URLSearchParams(legacySupportQueryParams);
        newSearchParams.forEach((value, key) => {
            if (append) {
                this.url.searchParams.append(key, value);
                return;
            }
            else {
                this.url.searchParams.set(key, value);
            }
        });
        return this;
    }
    addPath(path) {
        this.url.pathname = path;
        return this;
    }
    build() {
        return this.url.toString();
    }
    buildAbsolute() {
        return `${this.url.pathname}${this.url.search}${this.url.hash}`;
    }
}
exports.default = NextGenUrlBuilder;
//# sourceMappingURL=NextGenUrlBuilder.js.map